module.exports = __webpack_public_path__ + "assets/img/custom_new.5fc9da97.gif";